import React, { FC } from 'react';
import { useGetBranchByIdQuery } from '../../types/graphqlHelpers';
import Blade from '../Blade';
import { Loader } from '../Loader';
import { BranchContent } from './BranchBlade';

interface BranchBladeProps {
  branchId: string | number;
  prioritiseLettings?: boolean;
}

// This blade just wraps the standard branch blade, but with a a live query for the data
export const BranchBladeDynamic: FC<BranchBladeProps> = ({ branchId, prioritiseLettings }) => {
  const { data, loading, called } = useGetBranchByIdQuery({ variables: { id: branchId } });
  const branch = data?.branch?.branch;
  return (
    <Blade id="branch">
      {loading && <Loader />}
      {called && !loading && branch && (
        <BranchContent branch={branch} prioritiseLettings={prioritiseLettings} dynamic />
      )}
    </Blade>
  );
};
